/**
 * A running task's mark (spec 155 US2): a ring the size of a parent's
 * progress ring, with a quarter arc that turns while the agent works. In the
 * running colour, never the brand gradient, which is for progress (WD-07).
 * Under reduced motion the arc stays still.
 */
export function LiveRing({ size = 44 }: { size?: number }) {
  const radius = 18;
  const circumference = 2 * Math.PI * radius;
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 44 44"
      width={size}
      height={size}
      className="shrink-0"
      data-live-ring
    >
      <circle
        cx="22"
        cy="22"
        r={radius}
        fill="none"
        strokeWidth="5"
        className="stroke-muted"
      />
      <circle
        cx="22"
        cy="22"
        r={radius}
        fill="none"
        strokeWidth="5"
        strokeLinecap="round"
        strokeDasharray={`${String(circumference / 4)} ${String(circumference)}`}
        className="stroke-board-state-running origin-center motion-safe:animate-spin"
      />
    </svg>
  );
}
